"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "varese-ligure": {
    "07ea6375": [{
      "hkey": "5435a616",
      "slug": "cassego-villa",
      "name": "Cassego-Villa",
      "primary": true,
      "skipSearch": false
    }],
    "cassego": [{
      "hkey": "5435a616",
      "slug": "cassego-villa",
      "name": "Cassego-Villa",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "fd3d60c5": [{
      "hkey": "5e26a167",
      "slug": "caranza",
      "name": "Caranza",
      "primary": true,
      "skipSearch": false
    }],
    "cesena-caranza": [{
      "hkey": "5e26a167",
      "slug": "caranza",
      "name": "Caranza",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "394f7696": [{
      "hkey": "3cb89762",
      "slug": "varese-ligure",
      "name": "Varese Ligure",
      "primary": true,
      "skipSearch": false
    }],
    "porciorasco": [{
      "hkey": "3cb89762",
      "slug": "varese-ligure",
      "name": "Varese Ligure",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "82fe9c10": [{
      "hkey": "3cb89762",
      "slug": "varese-ligure",
      "name": "Varese Ligure",
      "primary": true,
      "skipSearch": false
    }],
    "teviggio": [{
      "hkey": "3cb89762",
      "slug": "varese-ligure",
      "name": "Varese Ligure",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "c5e49841": [{
      "hkey": "3cb89762",
      "slug": "varese-ligure",
      "name": "Varese Ligure",
      "primary": true,
      "skipSearch": false
    }],
    "trenzenasca": [{
      "hkey": "3cb89762",
      "slug": "varese-ligure",
      "name": "Varese Ligure",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;